export class OperatingHours {
	days: string;
	startTime: string;
	endTime: string;
	countryTimeZoneId: number;
}
